import script from "./SMSCampaignsFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsFooter.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsFooter.vue?vue&type=style&index=0&id=5cd05852&lang=scss"

const __exports__ = script;

export default __exports__